module.exports = "a";


/*****************
 ** WEBPACK FOOTER
 ** ./chunks/runtime/a.js
 ** module id = 9
 ** module chunks = 4 5
 **/